import { api } from "./api";

const basePath = "/upload";

export const uploadService = {
  uploadZzorder(selector, data, config) {
    return api.post(`${basePath}/zzorder/${selector}`, data, config);
  },
  uploadLogisticMap(selector, data, config) {
    return api.post(`${basePath}/logisticMap/${selector}`, data, config);
  },
};

export default uploadService;
